import { renderToTemplate } from './reactTemplate';

function PdfDownloadTemplate() {
  return (
    <div className="p-3 bg-lvl2 d-flex align-items-center gap-12px">
      <svg xmlns="http://www.w3.org/2000/svg" height={24} width={24} viewBox="0 0 24 24" fill="var(--bs-secondary)">
        <g>
          <path d="M0,0h24v24H0V0z" fill="none" />
        </g>
        <g>
          <path d="M15,3H5C3.9,3,3.01,3.9,3.01,5L3,19c0,1.1,0.89,2,1.99,2H19c1.1,0,2-0.9,2-2V9L15,3z M5,19V5h9v5h5v9H5z M9,8 c0,0.55-0.45,1-1,1S7,8.55,7,8s0.45-1,1-1S9,7.45,9,8z M9,12c0,0.55-0.45,1-1,1s-1-0.45-1-1s0.45-1,1-1S9,11.45,9,12z M9,16 c0,0.55-0.45,1-1,1s-1-0.45-1-1s0.45-1,1-1S9,15.45,9,16z" />
        </g>
      </svg>
      <div className="d-flex flex-column flex-grow-1">
        <span className="fw-bold">Product factsheet</span>
        <span className="fw-light">PDF</span>
      </div>
      <a className="btn btn-lg btn-flat-secondary btn-icon-end" href="#" rel="noopener,noreferrer" target="_blank">
        Download <i className="icon">save_alt</i>
      </a>
    </div>
  );
}

const template = renderToTemplate(<PdfDownloadTemplate />);

class TutorialPdfDownload extends HTMLElement {
  #url: string = '#';
  #anchor: Nullable<HTMLAnchorElement> = null;

  constructor() {
    super();
  }

  connectedCallback() {
    this.append(template.content.cloneNode(true));
    this.#anchor = this.querySelector('a');
    this.#anchor!.href = this.#url;
    this.#anchor!.setAttribute('aria-label', this.getDocumentNameFromUrl());
    this.#anchor?.addEventListener('click', TutorialPdfDownload.onClick);
  }

  disconnectedCallback() {
    if (this.#anchor) {
      this.#anchor.removeEventListener('click', TutorialPdfDownload.onClick);
      this.#anchor = null;
    }
  }

  static get observedAttributes() {
    return ['url'];
  }

  attributeChangedCallback(name: string, _oldValue: string, newValue: string) {
    if (name === 'url') {
      this.#url = newValue;
    }
  }

  getDocumentNameFromUrl() {
    const paths = new URL(this.#url)?.pathname ?? [];
    return decodeURIComponent(paths.split('/').pop() ?? '');
  }

  private static onClick({ target }: Event) {
    const documentName = (target as HTMLAnchorElement).getAttribute('aria-label');

    window._paq.push(['trackEvent', 'Help Center', `Download factsheet "${documentName}"`]);
  }
}

export const tutorialPdfDownloadTagName = 'tutorial-pdf-download';
window.customElements.define(tutorialPdfDownloadTagName, TutorialPdfDownload);
